module.exports = __webpack_public_path__ + "static/media/icici2.72a162a1.webp";